import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LabelStandardRegular } from '@front-core/typography';
import { DateTimeHelper } from '@shared/lib/helpers/dateTime';
import { StringHelper } from '@shared/lib/helpers/string';
import styles from './tooltip.scss';
const months = {
    янв: 0,
    февр: 1,
    март: 2,
    апр: 3,
    май: 4,
    июнь: 5,
    июль: 6,
    авг: 7,
    сент: 8,
    окт: 9,
    нояб: 10,
    дек: 11
};
const CustomTooltip = ({ active, payload, label }) => {
    const firstPayload = (payload === null || payload === void 0 ? void 0 : payload.length) ? payload[0] : null;
    const getFormattedDate = (date) => {
        const dateYear = date.replace(/^\D+/g, '');
        const month = date.replace(/\d/g, '').trim();
        const year = `20${dateYear}`;
        const newDate = new Date();
        newDate.setFullYear(Number(year));
        newDate.setMonth(months[month]);
        newDate.setDate(1);
        return DateTimeHelper.format(newDate, 'MMMM YYYY');
    };
    if (active && firstPayload) {
        return _jsxs("div", { className: styles.tooltip, children: [label && typeof label === 'string' ? _jsx(LabelStandardRegular, { tag: "span", className: styles.month, wrapper: false, children: getFormattedDate(label) }) : null, _jsx("div", { className: styles.item, children: _jsx(LabelStandardRegular, { tag: "span", wrapper: false, children: StringHelper.getPluralForm(firstPayload.payload.dealsCount, ['сделка', 'сделки', 'сделок'], true) }) })] });
    }
    return null;
};
export default CustomTooltip;
